import React, {useEffect, useState} from 'react'
import {LogosProvider} from "app/react/components/logos/LogosContext";

export default function LogosContainer ({
  children,
  headerTitle = '',
  headerText = '',
  selectLabel = '',
  selectOptions = [],
  initialOption = '',
  primaryLogoWeb = {},
  primaryLogoPrint = {},
  logoPackageTitle = '',
  logoPackageText = '',
  logos = [],
  files = [],
  buttonTexts = {}
}) {

  const [selectedOption, setSelectedOption] = useState(initialOption)

  const contextObjext = {
    headerTitle,
    headerText,
    selectLabel,
    selectOptions,
    selectedOption,
    setSelectedOption,
    primaryLogoWeb,
    primaryLogoPrint,
    logoPackageTitle,
    logoPackageText,
    logos,
    files,
    buttonTexts
  }

  return (
    <LogosProvider value={contextObjext}>
      {children}
    </LogosProvider>
  )
}